import {
  COMMON_MESSAGE,
  CONTRACTS_DATA,
  SWITCH_VALUE,
} from '../../../../constants';

export const initialState = {
  isFromCreateNewContract: false,
  viaAddNewContracts: false, // You can store the viaAddNewContracts here - User land to MainScrren via Add New Contracts
  isMainScreen: false,
  isAddNew: false,
  loading: false,
  errors: {
    accountingGroupName: null,
  }, // You can store the form errors here
  isActiveLoading: false, // You can store the active loading here
  isDeactiveLoading: false, // You can store the deactive loading here
  isResultsFound: false, // variable for result found here
  isContractsByIdResultsFound: false, // variable for result found here
  isContractsSearchResultsFound: false, // variable for result found here
  isAccountingGroupsResultsFound: false, // variable for result found here
  isCountryResultsFound: false, // variable for result found here
  isCustomersResultsFound: false, // variable for result found here
  isBillTosResultsFound: false, // variable for result found here
  isSitesResultsFound: false, // variable for result found here
  isBillToResultsFound: false, // variable for result found here
  isApprovalsResultsFound: false, // variable for result found here
  noDataFound: false, // variable for no data found here
  siteTypeData: [], // You can store the SiteType search data here
  apiSuccessResponse: {
    activate: false,
    deactivate: false,
    create: false,
    update: false,
  }, // You can store the api success response here
  isContractSuccessfullyCreated: false, // You can store the api success response here
  isContractInitiated: false, // You can store the api success response here
  isDuplicateContract: false, // You can store the api success response here
  // Add Contracts
  addContractData: {
    shortName: '',
    description: '',
    accountingGroupCode: '',
    accountingGroupName: COMMON_MESSAGE.select,
    countryId: 0,
    countryName: '',
    customerId: 0,
    customerName: '',
    billToId: 0,
    billToName: '',
    siteId: 0,
    siteName: '',
    contractId: 0,
    contractStatus: CONTRACTS_DATA.contractStatus,
    createdOnDate: new Date(),
    creatorFirstName: '',
    creatorLastName: '',
  },
  //Modals
  //Accounting Group
  openAccountingGroupModal: false, // You can store AccountingGrouo modal open status here
  accountingGroupSearchData: [], // You can store the AccountingGrouo search data here
  gridAccountingRowSelectedData: [], // You can store the grid row selected data here
  gridAccountingRowSelectedCount: 0, // You can store the grid rows selected count
  accountingGroups: [], // You can store the accounting groups here
  accountingGroupGridTotalRecords: 0, // You can store the total records of the grid here
  accountingGroupSearchForm: {
    accountingGroupCode: '',
    isActive: SWITCH_VALUE.yes,
    isResellerGroup: SWITCH_VALUE.blank,
  },
  //Country
  openCountryModal: false, // You can store Country modal open status here
  countrySearchData: [], // You can store the AccountingGrouo search data here
  gridCountryRowSelectedData: [], // You can store the grid row selected data here
  gridCountryRowSelectedCount: 0, // You can store the grid rows selected count
  countries: [], // You can store the accounting groups here
  countryGridTotalRecords: 0, // You can store the total records of the grid here
  countrySearchForm: {
    name: '',
    countryCode: '',
  },
  //Customer
  openCustomerModal: false, // You can store Customer modal open status here
  customerSearchData: [], // You can store the Customersearch data here
  gridCustomerRowSelectedData: [], // You can store the grid row selected data here
  gridCustomerRowSelectedCount: 0, // You can store the grid rows selected count
  customers: [], // You can store the customers here
  customerGridTotalRecords: 0, // You can store the total records of the grid here
  showCustomerSearchGrid: false, // You can store the view result button clicked here
  customerSearchForm: {
    name: '',
    customerId: '',
    accountingGroup: '',
    parentPsCustomerCode: '',
    activeFlag: COMMON_MESSAGE.yes,
    corporateCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
    billToCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
  },
  //BillTo
  openBillToModal: false, // You can store BillTo modal open status here
  billToSearchData: [], // You can store the BillTosearch data here
  gridBillToRowSelectedData: [], // You can store the grid row selected data here
  gridBillToRowSelectedCount: 0, // You can store the grid rows selected count
  billTos: [], // You can store the billtos here
  billToGridTotalRecords: 0, // You can store the total records of the grid here
  openBillToCorporateCustomerModal: false, // You can store BillTo modal open status here
  openBillToCustomerModal: false, // You can store BillTo modal open status here
  showBillToSearchGrid: false, // You can store the view result button clicked here
  billToSearchForm: {
    name: '',
    billToId: '',
    siteNumber: '',
    siteType: COMMON_MESSAGE.initialSelectValueForAny,
    active: COMMON_MESSAGE.yes,
    corporateCustomer: {
      name: '',
      customerId: 0,
      accountingGroup: '',
      parentPsCustomerCode: '',
      activeFlag: COMMON_MESSAGE.yes,
      corporateCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
      billToCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
    },
    billToCustomer: {
      name: '',
      customerId: 0,
      accountingGroup: '',
      parentPsCustomerCode: '',
      activeFlag: COMMON_MESSAGE.yes,
      corporateCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
      billToCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
    },
  },
  //Site
  openSiteModal: false, // You can store Site modal open status here
  siteSearchData: [], // You can store the Sitesearch data here
  gridSiteRowSelectedData: [], // You can store the grid row selected data here
  gridSiteRowSelectedCount: 0, // You can store the grid rows selected count
  sites: [], // You can store the accounting groups here
  siteGridTotalRecords: 0, // You can store the total records of the grid here
  openSiteCorporateCustomerModal: false, // You can store BillTo modal open status here
  openSiteBillToCustomerModal: false, // You can store BillTo modal open status here
  showSiteSearchGrid: false, // You can store the view result button clicked here
  siteSearchForm: {
    name: '',
    siteId: '',
    siteNumber: '',
    siteType: COMMON_MESSAGE.initialSelectValueForAny,
    active: COMMON_MESSAGE.yes,
    corporateCustomer: {
      name: '',
      customerId: 0,
      accountingGroup: '',
      parentPsCustomerCode: '',
      activeFlag: COMMON_MESSAGE.yes,
      corporateCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
      billToCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
    },
    billToCustomer: {
      name: '',
      customerId: 0,
      accountingGroup: '',
      parentPsCustomerCode: '',
      activeFlag: COMMON_MESSAGE.yes,
      corporateCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
      billToCustomer: COMMON_MESSAGE.dropDownDefaultValueForAny,
    },
  },
  //End Modals
};
